<script>
import BaseDropdown from './BaseDropdown';
import { getRangeOfYears, UtcDate } from '@/helpers/date';

export default {
  name: 'question-base-year-dropdown',
  extends: BaseDropdown,
  props: {
    rangeFromCurrentYear: {
      type: Number,
      default: 100,
    },
    convertItemsToString: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fieldOptions () {
      return getRangeOfYears(this.rangeFromCurrentYear, new UtcDate().getFullYear(), this.convertItemsToString);
    },
  },
};
</script>
